export const configuration = {
  holidays: ["6", "0"],
  operationTimeFrom: "10:00",
  operationTimeTo: "17:00",
  orderGrabTakeOutFrom: "12:00",
  orderGrabEatInFrom: "12:00",
  orderGrabEatInTo: "16:30",
  orderGrabTakeOutTo: "16:30",
  orderGrabTakeOutPayOnlineTo: "16:30",
  orderGrabDeliveryTo: "17:00",
  orderMakeFrom: "08:00",
  orderMakeEatInTo: "14:00",
  orderMakeTakeOutTo: "14:00",
  isOnlinePaymentAllowed: true,
  isDeliveryAllowed: true,
  isOrdersAllowed: true,
  isSMSAllowed: false,
  freeDeliveryMinPrice: "30",
  deliveryPrice: "3",
  deliveryPrice2: "5",
  deliveryOrderMinPrice: "10",
  __v: 9
};
